const dentalServices = [
  {
    icon: "ri-tooth-line",
    title: "Limpeza e Prevenção",
    desc: "Profilaxia completa, remoção de tártaro e orientação para manter sua saúde bucal em dia.",
    tag: "Mais procurado",
    tagColor: "bg-secondary/10 text-secondary",
  },
  {
    icon: "ri-surgical-mask-line",
    title: "Extração",
    desc: "Extrações simples e complexas com técnica delicada para seu conforto e segurança.",
    tag: null,
    tagColor: "",
  },
  {
    icon: "ri-medicine-bottle-line",
    title: "Restauração",
    desc: "Restaurações em resina de alta qualidade para recuperar a função e estética do seu dente.",
    tag: null,
    tagColor: "",
  },
  {
    icon: "ri-award-line",
    title: "Prótese Dentária",
    desc: "Próteses totais, parciais e sobre implantes com laboratório próprio para agilidade máxima.",
    tag: "Lab próprio",
    tagColor: "bg-primary-50 text-primary-700",
  },
  {
    icon: "ri-sun-line",
    title: "Clareamento Dental",
    desc: "Clareamento a laser ou com moldeiras para um sorriso mais branco e radiante com segurança.",
    tag: "Alta demanda",
    tagColor: "bg-secondary/10 text-secondary",
  },
  {
    icon: "ri-alarm-warning-line",
    title: "Urgência e Emergência",
    desc: "Atendimento de urgência para dores, fraturas e infecções com prioridade e agilidade.",
    tag: "Imediato",
    tagColor: "bg-red-50 text-red-600",
  },
  {
    icon: "ri-star-smile-line",
    title: "Facetas de Porcelana",
    desc: "Lâminas ultrafinas de porcelana que transformam o sorriso com naturalidade, cor e formato perfeitos.",
    tag: "Transformação",
    tagColor: "bg-secondary/10 text-secondary",
  },
];

const harmonizacaoServices = [
  {
    icon: "ri-drop-line",
    title: "Preenchimento Labial",
    desc: "Realce e definição dos lábios com ácido hialurônico, proporcionando volume natural e harmonioso.",
    tag: "Mais pedido",
    tagColor: "bg-secondary/10 text-secondary",
  },
  {
    icon: "ri-thread-line",
    title: "Fios de PDO",
    desc: "Lifting não cirúrgico com fios de PDO para reposicionamento e sustentação dos tecidos faciais.",
    tag: "Sem cirurgia",
    tagColor: "bg-primary-50 text-primary-700",
  },
  {
    icon: "ri-syringe-line",
    title: "Toxina Botulínica (Botox)",
    desc: "Aplicação precisa de botox para suavizar rugas de expressão e prevenir o envelhecimento facial.",
    tag: "Alta demanda",
    tagColor: "bg-secondary/10 text-secondary",
  },
  {
    icon: "ri-leaf-line",
    title: "Peeling Químico",
    desc: "Renovação celular profunda para uniformizar textura, manchas e sinais de envelhecimento da pele.",
    tag: null,
    tagColor: "",
  },
  {
    icon: "ri-magic-line",
    title: "Preenchimento Facial",
    desc: "Reposição de volume em maçãs do rosto, olheiras e mandíbula para uma aparência mais jovem.",
    tag: null,
    tagColor: "",
  },
  {
    icon: "ri-heart-pulse-line",
    title: "Bichectomia",
    desc: "Procedimento minimamente invasivo para afinar o rosto e realçar a definição do contorno facial.",
    tag: null,
    tagColor: "",
  },
];

interface ServiceCardProps {
  icon: string;
  title: string;
  desc: string;
  tag: string | null;
  tagColor: string;
}

function ServiceCard({ icon, title, desc, tag, tagColor }: ServiceCardProps) {
  return (
    <div className="group bg-white border border-gray-100 rounded-2xl p-6 hover:border-primary-200 hover:shadow-md transition-all">
      <div className="flex items-start justify-between mb-4">
        <div className="w-12 h-12 flex items-center justify-center bg-primary-50 group-hover:bg-primary-700 rounded-xl text-primary-700 group-hover:text-white transition-colors text-2xl">
          <i className={icon}></i>
        </div>
        {tag && (
          <span className={`text-xs font-semibold px-3 py-1 rounded-full ${tagColor}`}>
            {tag}
          </span>
        )}
      </div>
      <h4 className="font-bold text-primary-700 text-base mb-2">{title}</h4>
      <p className="text-gray-500 text-sm leading-relaxed">{desc}</p>
    </div>
  );
}

export default function ServicesSection() {
  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="servicos" className="py-16 md:py-24 bg-white">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-16">
          <span className="text-secondary font-semibold text-sm uppercase tracking-widest">O que oferecemos</span>
          <h3 className="text-2xl md:text-4xl font-extrabold text-primary-700 mt-3 mb-4">
            Nossos Serviços
          </h3>
          <p className="text-gray-500 max-w-lg mx-auto text-sm md:text-base">
            Tratamentos completos para toda a família com preços acessíveis e parcelamento na hora.
          </p>
        </div>

        {/* Odontologia */}
        <div className="mb-10 md:mb-14">
          <div className="flex items-center gap-3 mb-5 md:mb-6 overflow-hidden">
            <div className="w-9 h-9 flex-shrink-0 flex items-center justify-center bg-primary-700 rounded-xl text-white text-lg">
              <i className="ri-tooth-line"></i>
            </div>
            <h4 className="text-lg md:text-xl font-extrabold text-primary-700 whitespace-nowrap">Odontologia</h4>
            <div className="flex-1 h-px bg-gray-100 min-w-0"></div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
            {dentalServices.map((service) => (
              <ServiceCard key={service.title} {...service} />
            ))}
          </div>
        </div>

        {/* Harmonização Facial */}
        <div className="mb-8 md:mb-12">
          <div className="flex items-center gap-3 mb-5 md:mb-6 overflow-hidden">
            <div className="w-9 h-9 flex-shrink-0 flex items-center justify-center bg-secondary rounded-xl text-white text-lg">
              <i className="ri-magic-line"></i>
            </div>
            <h4 className="text-lg md:text-xl font-extrabold text-primary-700 whitespace-nowrap">Harmonização Facial</h4>
            <div className="flex-1 h-px bg-gray-100 min-w-0"></div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
            {harmonizacaoServices.map((service) => (
              <ServiceCard key={service.title} {...service} />
            ))}
          </div>
        </div>

        <div className="mt-4 text-center">
          <a
            href="#contato"
            onClick={(e) => { e.preventDefault(); scrollTo("#contato"); }}
            className="inline-flex items-center gap-2 bg-primary-700 hover:bg-primary-800 text-white font-bold px-7 py-4 rounded-full transition-colors cursor-pointer w-full sm:w-auto justify-center"
          >
            <i className="ri-calendar-2-line"></i>
            Agendar minha consulta
          </a>
        </div>
      </div>
    </section>
  );
}
